import Reveal from "@/components/base/Reveal";

const VIDEOS = [
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/0aa10208-6a3e-4307-97e5-0cfc7583f7db_powermotoreseletricos-1.mp4",
    title: "Estrutura e estoque da Power",
    description: "Conheça o galpão, os motores em estoque e a infraestrutura industrial.",
    poster:
      "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/f208b552-5791-4996-9924-1b3d711b32f2_compressed_powermotoreseletricos-20.webp",
  },
  {
    src: "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/d4e3996c-a05d-4414-a51d-470dd3947bb5_powermotoreseletricos.mp4",
    title: "Nosso trabalho em ação",
    description: "Equipe técnica, motores e o dia a dia de quem mantém sua produção em movimento.",
    poster:
      "https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/be905cfd-9451-4f2b-bcfe-60a259e58cc5_compressed_powermotoreseletricos-14.webp",
  },
];

export default function Videos() {
  return (
    <section id="videos" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <p className="text-center text-xs font-bold uppercase tracking-[0.16em] text-accent-600">
            Vídeos
          </p>
          <h2 className="mt-3 text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Veja a Power em ação
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-base text-foreground-600">
            Um olhar por dentro da nossa estrutura, estoque e equipe técnica.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
          {VIDEOS.map((video, i) => (
            <Reveal key={video.title} delay={i * 100}>
              <figure className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="relative overflow-hidden bg-primary-950">
                  <video
                    src={video.src}
                    poster={video.poster}
                    controls
                    preload="metadata"
                    playsInline
                    aria-label={video.title}
                    className="aspect-video w-full object-cover"
                  />
                </div>
                <figcaption className="p-5 md:p-6">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                    {video.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {video.description}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}